//Fetch shim
import 'whatwg-fetch'
import config from './config'
import ResponseHandler from './ResponseHandler'
import download from 'downloadjs'

import moment from 'moment'



class QueryService {

  _book = null

  constructor(book) {
    if (book) this._book = book
  }

  get book() { return this._book }
  set book(book) { this._book = book }



  createQueryParams(obj) {
    if (this.book) obj = {...obj, book: this.book.name}
    let query = ''
    obj && Object.keys(obj).forEach(k => {
      query += encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]) + '&'
    })
    if (query !== '') {
      query = '?' + query.substring(0, query.length-1)
    }
    return query
  }
  
  callAPI(endpoint, params) {
    return fetch(config.backend[process.env.NODE_ENV] + endpoint + this.createQueryParams(params), config.fetchOptions)
      .then(new ResponseHandler().handle((response) => response.json()))
  }
  

  // -- methods -- //

  getBalanceSummary(postDate) {
    return this.callAPI('/dashboard/balance_summary', {post_date : postDate.toISOString()})
  }
  
  getBalanceSummaryLocal(postDate) {
    let params = {post_date : postDate.toISOString()}
    return this.callAPI('/dashboard/balance_summary_local', params)
  }
  
  getBalanceAccounts(journal, postDate) {
    let params = {journal: journal, post_date : postDate.toISOString()}
    return this.callAPI('/dashboard/balanceaccounts', params)
  }
  
  
  getAccountBalanceSummary(account, postDate) {
    let params = {account: account, post_date : postDate.toISOString()}
    return this.callAPI('/dashboard/account_balance_summary', params)
  }
  
  getAccountBalanceDetails(account, postDate, limit) {
    let params = {account: account, post_date: postDate.toISOString(), limit: limit}
    return this.callAPI('/dashboard/account_balance_details', params)
  }
  
  getAccountSchedule(account, postDate, limit) {
    let params = {account: account, post_date: postDate.toISOString(), limit: limit}
    return this.callAPI('/dashboard/account_schedule', params)
  }
  
  getAgingSummary(postDate, status) {
    let params = {post_date : moment(postDate).format()}
    console.log('--- Status:', status)
    if (status && status != '') params.contract_status = status
    return this.callAPI('/dashboard/aging_summary', params)
  }
  
  getAgingAccountsFirst(postDate, status) {
    let params = {post_date : moment(postDate).format()}
    if (status && status != '') params.contract_status = status
    return this.callAPI('/dashboard/aging_accounts_first', params)
  }
  
  getAgingAccounts(postDate, status) {
    let params = {post_date : moment(postDate).format()}
    if (status && status != '') params.contract_status = status
    return this.callAPI('/dashboard/aging_accounts', params)
  }
  
  getTransactionSummary(postStartDate, postEndDate) {
    let params = {
      post_date_start : postStartDate.toISOString(),
      post_date_end : postEndDate.toISOString()
    }
    return this.callAPI('/dashboard/transactionsummary', params)
  }
  
  getUpcomingPayments(fromDate, toDate) {
    let params = {
      from_date : fromDate.toISOString(),
      to_date : toDate.toISOString()
    }
    return this.callAPI('/dashboard/upcoming_payments', params)
  }
  
  getSellerBalanceSummary(postDate) {
    let params = {post_date : postDate.toISOString()}
    return this.callAPI('/dashboard/sellers/summary', params)
  }
  
  getSellerBalanceBySeller(postDate, pageNumber, pageSize, sort, filter) {
    let paramJson = {post_date: postDate.toISOString()};
    if (pageNumber) paramJson['pageNumber'] = pageNumber;
    if (pageSize) paramJson['pageSize'] = pageSize;
    if (sort) paramJson['sort'] = sort;
    if (filter) paramJson['filter'] = filter;
    let params = paramJson
    return this.callAPI('/dashboard/sellers/', params)
    //return fetch('/seller-page' + pageNumber + '.json', params;
  }
  
  downloadSellerBalances(postDate, sort, filter) {
    let filename = 'seller_dashboard_' + postDate + '.csv';
    let paramJson = {post_date: postDate.toISOString(), type: 'csv'};
    if (sort) paramJson['sort'] = sort;
    if (filter) paramJson['filter'] = filter;
    let params = this.createQueryParams(paramJson)
    let url = config.backend[process.env.NODE_ENV] + '/dashboard/sellers/' + params
    download(url, filename, 'text/csv')
  }
  
  getSearchResults(search, limit) {
    let params = {search : search, limit: limit}
    return this.callAPI('/dashboard/search', params)
  }
  
  getMaxDate() {
    console.log(this.book)
    return this.callAPI('/dashboard/maxdate')
  }

}

export { QueryService }



// WEBPACK FOOTER //
// ./src/services/queries.js